import React from 'react';

const Icon = ({ width = '12', height = '15', fill = 'black', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 12 15" fill="none" {...other}>
            <path d="M.343 7.454 11.718.887v13.134L.343 7.454Z" fill={fill} />
        </svg>
    );
};
export default React.memo(Icon);
